<template>
  <div class="v-summary">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4" lg="3" xl="2">
          <ProjectsList :simple="true" />
        </v-col>
        <v-col cols="12" md="8" lg="9" xl="10" v-if="selectedProject">
          <MetricsChartsByProject
            :key="selectedProject"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'PRMatrixCharts',
  components: {
    ProjectsList: () => import('@/components/tasks_editor/ProjectsList.vue'),
    MetricsChartsByProject: () => import('@/components/metrics/MetricsChartsByProject.vue')
  },
  data () {
    return {
    }
  },
  computed: {
    selectedProject () {
      return this.$store.getters.getSelectedProject
    }
  }
}
</script>
